import { useMutation } from '@tanstack/react-query';
import { AxiosInstance, AxiosResponse } from 'axios';
import { ApiRoutes } from 'src/common/api/ApiRoutes';
import { useAxiosSocket } from 'src/common/api/AxiosContext';
import { SocketSessionProps } from 'src/common/api/response';
import StorageHelper from 'src/common/utils/StorageHelper';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';

// 1440 minute = 24h
const timestamp = 1440;

export const handleFetchSocketToken = (axios: AxiosInstance) => {
  // return axios.post<SocketSessionProps>(`${ApiRoutes.getSession}?ttl=3600`, {});
  return axios.post<SocketSessionProps>(`${ApiRoutes.getSession}?ttl=${timestamp}`, {});
  // return axios.get<AxiosResponse<SocketSessionProps>>(`healthz`, {});
};

export const handleFetchSocketSuccess = async (response: AxiosResponse) => {
  try {
    // response.data.expiresIn === seconds
    const accessToken = `${response.data.tokenType} ${response.data.accessToken}`;
    const dateTimestamp = Date.now() + response.data.expiresIn * 1000;

    await StorageHelper.saveSocketToken(accessToken, `${dateTimestamp}`);
  } catch (error) {
    console.log({ error });
  }
};

export const useSocketSessionMutation = () => {
  const axios = useAxiosSocket();

  return useMutation(() => handleFetchSocketToken(axios), {
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    onSuccess: handleFetchSocketSuccess,
    // onError: (error: AxiosError) => {
    //   console.log({ error });
    //   if (error.code === '401') {
    //     // refresh token
    //   }
    // },
  });
};
